import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=4f58b317"
import script from "./Address.js?vue&type=script&lang=js&external"
export * from "./Address.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports